import React, { useEffect, useState, useContext } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Link,
  Grid,
  Backdrop,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import * as consts from "../consts";
import { State } from "../store/state";
import {
  dismissAlert,
  getProfile,
  getCartQuote,
  setBusy,
  setBilling,
  getShippingMethods,
} from "../store/actions";
import CouponInput from "./controls/couponInput";
import EmailQuote from "./controls/emailQuote";
import PlasticQuote from "./controls/plasticQuote";
import PrintQuote from "./controls/printQuote";
import TotalQuote from "./controls/totalQuote";
import Payment from "./controls/payment";
import Share from "./controls/share";
import Alert from "./presentational/alert";

const App = (props) => {
  const generateClassName = createGenerateClassName({
    seed: "tbcheckout",
  });

  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    main: { paddingTop: theme.spacing(2) },
    link: {
      cursor: "pointer",
      margin: "0px",
      whiteSpace: "nowrap",
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#ffffff",
    },
    summaryArea: {
      margin: "0px",
    },
    container: {
      margin: "0px",
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const { isLoading, isAuthenticated, user, getAccessTokenSilently } =
    useAuth0();

  const [quote, setQuote] = useState([]);

  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      let updatedBilling = { ...state.billing, email: user.email };
      getProfile(getAccessTokenSilently, dispatch).then((profile) => {
        if (
          profile &&
          profile.addressBook &&
          profile.addressBook.billing &&
          state.billing.firstName == "" &&
          state.billing.lastName == "" &&
          state.billing.company == "" &&
          state.billing.address == "" &&
          state.billing.city == "" &&
          state.billing.state == consts.DEFAULT_BILLING_STATE &&
          state.billing.zip == ""
        ) {
          updatedBilling.firstName = profile.addressBook.billing.firstName;
          updatedBilling.lastName = profile.addressBook.billing.lastName;
          updatedBilling.company = profile.addressBook.billing.company;
          updatedBilling.address = profile.addressBook.billing.address;
          updatedBilling.city = profile.addressBook.billing.city;
          updatedBilling.state = profile.addressBook.billing.state;
          updatedBilling.zip = profile.addressBook.billing.zip;
        }
      });
      setBilling(updatedBilling, dispatch);
    }
  }, [isAuthenticated, isLoading, user]);

  useEffect(() => {
    if (state.cart) {
      setBusy(true, dispatch).then(() => {
        getShippingMethods(dispatch).then((shippingMethods) => {
          getCartQuote(
            state.cart,
            shippingMethods,
            getAccessTokenSilently,
            dispatch
          ).then((quote) => {
            setQuote(quote);
            setBusy(false, dispatch);
          });
        });
      });
    }
  }, [state.cart]);

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline className={classes.main}>
          <Backdrop className={classes.backdrop} open={state.busy}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {state.alerts.length > 0 && (
            <Alert
              alert={state.alerts[0]}
              onDismiss={() => {
                dismissAlert(dispatch);
              }}
            />
          )}
          <Grid
            item
            container
            xs={12}
            spacing={2}
            className={classes.container}
          >
            {!state.quoteid && (
              <Grid item xs={12}>
                <Typography variant="h5">
                  <Link
                    className={classes.link}
                    onClick={() => {
                      window.location.href = "/shop";
                    }}
                    color="secondary"
                  >
                    <ArrowBackIcon fontSize="small" className={classes.icon} />
                    <span>Continue Shopping</span>
                  </Link>
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} md={7}>
              <Grid item container xs={12}>
                <PlasticQuote quote={quote} />
                <EmailQuote quote={quote} />
                <PrintQuote quote={quote} />
              </Grid>
            </Grid>
            <Grid item xs={12} md={5}>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                className={classes.summaryArea}
              >
                <Grid item xs={12}>
                  <TotalQuote quote={quote} />
                </Grid>
                <Grid item xs={12}>
                  <CouponInput quote={quote} />
                </Grid>
                <Grid item xs={12}>
                  <Payment quote={quote} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
